export default{
	methods: {
		dateRangeLimit(dateStart,dateEnd){
			let days = dateEnd.diff(dateStart, 'days');
			if(days>365){
				this.$root.showAlert(this.$t("reports.rangeLimit",{days:"365"}),{variant:"warning"});
				throw new Error("Date range limit")
			}
		}
	}
  };
